import React from 'react';
import { COLORS } from '../../theme';

export function Campo({ label, children, style }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 3, fontSize: 11, fontWeight: 600, color: COLORS.textMid, ...style }}>
      {label}
      {children}
    </label>
  );
}

const baseStyle = {
  width: '100%',
  boxSizing: 'border-box',
  border: `1.5px solid ${COLORS.border}`,
  borderRadius: 7,
  padding: '8px 10px',
  fontSize: 13,
  color: COLORS.text,
  background: COLORS.bg,
  outline: 'none'
};

export function Input({ label, style, onWheel, ...props }) {
  // Evita o comportamento padrão do navegador de alterar o valor de inputs
  // numéricos ao rolar o mouse por cima (some campos ficam focados sem querer).
  const tratarWheel = (e) => {
    if (props.type === 'number') e.target.blur();
    if (onWheel) onWheel(e);
  };
  const campo = <input {...props} style={{ ...baseStyle, ...style }} onWheel={tratarWheel} />;
  return label ? <Campo label={label}>{campo}</Campo> : campo;
}

export function Select({ label, options = [], style, ...props }) {
  const campo = (
    <select {...props} style={{ ...baseStyle, ...style }}>
      {options.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
  return label ? <Campo label={label}>{campo}</Campo> : campo;
}

export default Input;
